export enum DateEnum {
    DEFAULT = 'YYYY-MM-DDTHH:MM:SSZ',
    MAX_MONTH_REPORT = 3,
    MAX_DAYS_TO_EXCEL = 7,
    YYYY_MM_DD = 'YYYY-MM-DD',
    YYYY_MM_DD_ZZ = 'YYYY-MM-DD ZZ',
    YYYY_MM_DD_HH_mm_ZZ = 'YYYY-MM-DD HH:mm ZZ',
    YYYY_MM_DD_HH_mmZZ = 'YYYY-MM-DD HH:mmZZ',
}
